import { ConfigService } from '@bo-client/config/config.service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import {
  ActionWithMoreInfoModel,
  DataForCustomFormModel
} from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { RequestModel } from '@bo-client/shared/models/request.model';
import { UserDto } from '@bo-client/shared/models/userDto';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';
import { RequestFormBase } from '@bo-client/shared/base-components/request-form.base';
import { uri } from '@bo-client/shared/constants/uri';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';
import { ContactDataDto } from '@bo-client/shared/models/contactDataDto';
import { AuthorizationService } from '@bo-client/core/authorization/authorization.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  PageActionExecutorService,
  RequestPageContext
} from '@bo-client/shared/request-support/page-action-executor.service';
import { RequestFormPort } from '@bo-client/shared/request-support/request-form-port';

export abstract class RequestPageBase<T extends RequestModel> implements RequestPageContext<T> {
  router = inject(Router);
  public title: any;
  public form: RequestFormBase<T> & RequestFormPort<T>;
  saveUrl: string = uri.cmGridRegistration;

  public user: UserDto = null;
  public errorFormList: ShowErrorModel[] = [];
  public actions: ActionWithMoreInfoModel[];
  public model: T = null;
  public createdByCustomer: ContactDataDto = null;

  compUnsub$ = new Subject<void>();

  constructor(
    protected configService: ConfigService,
    protected dataShareService: DataShareService,
    protected authorizationService: AuthorizationService,
    public matDialog: MatDialog,
    public httpService: HttpHapService,
    public toastService: ToastrService,
    protected pageActionExecutor: PageActionExecutorService
  ) {}

  onFormErrorsChanged(formErrorChangedEvent: ShowErrorModel[]) {
    this.errorFormList = formErrorChangedEvent;
  }

  get isEditor() {
    try {
      return !!this.user.roles.find((x) => x.name === 'ROLE_EDITOR_BASE');
    } catch (e) {
      return false;
    }
  }

  confirmActionWithComment(actionInfo: ActionWithMoreInfoModel) {
    this.pageActionExecutor.confirmActionWithComment(this, actionInfo);
  }

  confirmAction(actionInfo: ActionWithMoreInfoModel) {
    this.pageActionExecutor.confirmAction(this, actionInfo);
  }

  customAction(actionInfo: ActionWithMoreInfoModel) {
    const dataForCustomForm: DataForCustomFormModel<unknown> = new DataForCustomFormModel();
    dataForCustomForm.actionInfo = actionInfo;
    dataForCustomForm.model = this.model;
    this.hookCustomAction(dataForCustomForm);
  }

  protected hookCustomAction(dataForCustomForm: DataForCustomFormModel<unknown>) {}

  /*
   * Das Custom Form bringt seine eigene Validierung mit.
   * @param actionInfo
   */
  customFormWithCustomActionModal(actionInfo: ActionWithMoreInfoModel) {
    this.pageActionExecutor.customFormWithCustomActionModal(this, actionInfo);
  }

  saveAndActionPlusMail(actionData: ActionWithMoreInfoModel, model: T = null) {
    this.pageActionExecutor.saveAndActionPlusMail(this, actionData, model);
  }

  save(actionInfo: ActionWithMoreInfoModel, model: T = null) {
    this.pageActionExecutor.save(this, actionInfo, model);
  }

  remove(actionInfo: ActionWithMoreInfoModel, model: T = null) {
    this.pageActionExecutor.remove(this, actionInfo, model);
  }

  /**
   * Todo: handle form validation elsewhere. this is too generic.
   * @param action
   */
  executeAction(action: ActionWithMoreInfoModel) {
    this.pageActionExecutor.executeAction(this, action);
  }

  updateMainForm(result: T) {
    this.model = result;
    this.form.updateFormWithModel(result);
  }
}
